var _rect, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutologsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 768",
    width: 768,
    height: 768,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    rx: 172,
    ry: 172,
    fill: "#0D1B2E"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "56%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontFamily: "'SF Pro Display', 'Nunito', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 340,
    fontWeight: 700,
    letterSpacing: -10,
    fill: "#8AB4E8"
  }, "AL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutologsIcon);
export default __webpack_public_path__ + "static/media/autologs-icon.550ce53e34ba9445641e1e8e785f515e.svg";
export { ForwardRef as ReactComponent };